// FETCH ALL PROPERTIES FROM GENERAL_DC DETAILS
export const FETCH_GENERAL_DC_DETAILS_REQUEST_DK = 'FETCH_GENERAL_DC_DETAILS_REQUEST_DK';
export const FETCH_GENERAL_DC_DETAILS_SUCCESS_DK = 'FETCH_GENERAL_DC_DETAILS_SUCCESS_DK';
export const FETCH_GENERAL_DC_DETAILS_FAILURE_DK = 'FETCH_GENERAL_DC_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM GENERAL_DC DETAILS BY ID
export const FETCH_GENERAL_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_GENERAL_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_GENERAL_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_GENERAL_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_GENERAL_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_GENERAL_DC_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR GENERAL_DC DETAILS
export const CREATE_GENERAL_DC_DETAILS_REQUEST_DK = 'CREATE_GENERAL_DC_DETAILS_REQUEST_DK';
export const CREATE_GENERAL_DC_DETAILS_SUCCESS_DK = 'CREATE_GENERAL_DC_DETAILS_SUCCESS_DK';
export const CREATE_GENERAL_DC_DETAILS_FAILURE_DK = 'CREATE_GENERAL_DC_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_GENERAL_DC_DETAILS_DK = 'CREATE_USER_FORM_GENERAL_DC_DETAILS_DK';

// UPDATE PROPERTIES FOR GENERAL_DC DETAILS
export const UPDATE_GENERAL_DC_DETAILS_REQUEST_DK = 'UPDATE_GENERAL_DC_DETAILS_REQUEST_DK';
export const UPDATE_GENERAL_DC_DETAILS_SUCCESS_DK = 'UPDATE_GENERAL_DC_DETAILS_SUCCESS_DK';
export const UPDATE_GENERAL_DC_DETAILS_FAILURE_DK = 'UPDATE_GENERAL_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE GENERAL_DC_DETAILS
export const FETCH_SINGLE_GENERAL_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_GENERAL_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_GENERAL_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_GENERAL_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_GENERAL_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_GENERAL_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR GENERAL_DC DETAILS
export const DELETE_GENERAL_DC_DETAILS_REQUEST_DK = 'DELETE_GENERAL_DC_DETAILS_REQUEST_DK';
export const DELETE_GENERAL_DC_DETAILS_SUCCESS_DK = 'DELETE_GENERAL_DC_DETAILS_SUCCESS_DK';
export const DELETE_GENERAL_DC_DETAILS_FAILURE_DK = 'DELETE_GENERAL_DC_DETAILS_FAILURE_DK';

export const FETCH_GENERAL_DC_PREVIOUS_LIST_REQUEST_DK = 'FETCH_GENERAL_DC_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_GENERAL_DC_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_GENERAL_DC_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_GENERAL_DC_PREVIOUS_LIST_FAILURE_DK = 'FETCH_GENERAL_DC_PREVIOUS_LIST_FAILURE_DK';

// USERFORM RESET

export const GENERAL_DC_DETAILS_USERFORM_RESET_DK = 'GENERAL_DC_DETAILS_USERFORM_RESET_DK';

// FETCH ALL GENERAL DC DETAILS
export const FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_GENERAL_DC_DETAILS_WITHOUT_ID_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GENERAL_DC_DETAILS_GROUP_LIST_REQUEST_DK = 'FETCH_GENERAL_DC_DETAILS_GROUP_LIST_REQUEST_DK';
export const FETCH_GENERAL_DC_DETAILS_GROUP_LIST_SUCCESS_DK = 'FETCH_GENERAL_DC_DETAILS_GROUP_LIST_SUCCESS_DK';
export const FETCH_GENERAL_DC_DETAILS_GROUP_LIST_FAILURE_DK = 'FETCH_GENERAL_DC_DETAILS_GROUP_LIST_FAILURE_DK';


